import React from 'react';
import AiSearchPage from './components/AiSearchPage';
import IdentifiedPageContent from './components/IdentifiedList/IdentifiedPageContent';
import {
    IdentifiedListContext,
    useIdentifiedListContextProvider,
} from './components/IdentifiedList/utils/IdentifiedListContext';
import {
    AiSearchProfilePopoutContext,
    useAiSearchProfilePopoutContextProvider,
} from './components/AiSearchProfilePopout/AiSearchProfilePopoutContext';

const IdentifiedAiSearchPage = () => {
    return (
        <AiSearchPage>
            <AiSearchProfilePopoutContext.Provider
                value={useAiSearchProfilePopoutContextProvider({ hideEmailThreads: true })}
            >
                <IdentifiedListContext.Provider value={useIdentifiedListContextProvider()}>
                    <IdentifiedPageContent />
                </IdentifiedListContext.Provider>
            </AiSearchProfilePopoutContext.Provider>
        </AiSearchPage>
    );
};

export default IdentifiedAiSearchPage;
